import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as removeSelectors from '@store/dashboards/remove/selectors';
import { removePopupVisibleSelector } from '@store/dashboards/ui/selectors';
import * as dashboardsUIActions from '@store/dashboards/ui/actions';
import * as dashboardRemoveActions from '@store/dashboards/remove/actions';
import RemoveDashboardPopup from './RemoveDashboardPopup';

const selector = createSelector(
  removePopupVisibleSelector,
  removeSelectors.removeLoaderSelector,
  removeSelectors.errorCodeSelector,
  removeSelectors.payloadSelector,
  // We'll inject the defaultLandingPage from Zustand in the component
  (visible, isFetching, errorCode, payload) => ({
    visible,
    isFetching: !!payload && isFetching,
    hasError: errorCode !== 0,
    // defaultLandingPage will be provided via Zustand
  }),
);

export default connect(selector, {
  toggleVisible: dashboardsUIActions.toggleRemovePopupVisible,
  init: dashboardRemoveActions.initRequest,
  removeDashboard: dashboardRemoveActions.removeDashboardById,
  // updateDefaultLandingPage will be provided via Zustand
})(RemoveDashboardPopup);
